// Portal step 1: the school's locked requirements, ported from
// Buy Flow.dc.html. Each row is tappable to reveal the school's "why" (the
// server already sends reasons on the requirements object).
import { useState } from 'react';
import Wordmark from '@/components/Wordmark.jsx';

const money = (v) => `$${Number(v || 0).toLocaleString('en-US')}`;

export default function Requirements({ school, onContinue }) {
  const [openWhy, setOpenWhy] = useState(null);
  const req = school.requirements || {};
  const rows = [
    ['liability', 'Liability', req.liability
      ? `${money(req.liability.limit)}${req.liability.excluding_passengers ? ' excl. pax' : ` / ${money(req.liability.pax_sublimit)} pax`}` : '', req.reasons?.liability],
    ['damage', 'Damage to the rented aircraft', money(req.damage_limit?.limit), req.reasons?.damage_limit],
    ...(Number(req.deductible_reimb?.limit) > 0
      ? [['ded', 'Deductible reimbursement', money(req.deductible_reimb.limit), req.reasons?.deductible_reimb]] : []),
    ['med', 'Medical expense', `${money(req.medical?.limit)} included`, req.reasons?.medical],
  ];

  return (
    <>
      <h1 className="mb-1.5 mt-1.5 text-[23px] font-bold leading-[1.2] tracking-[-0.02em]">
        You&apos;re 2 minutes from being <Wordmark className="text-primary" />
      </h1>
      <p className="mb-[18px] text-sm leading-[1.55] text-ink-dim">
        {school.name} requires every renter to carry the coverage below. We&apos;ve already set it up for you,
        so you can&apos;t get it wrong.
      </p>
      <div className="mb-3 overflow-hidden rounded-panel border-[1.5px] border-primary bg-white">
        <div className="flex items-center justify-between gap-2.5 bg-teal-fill p-[13px_18px]">
          <span className="text-sm font-bold text-primary">✓ {school.name}&apos;s required coverage</span>
          <span className="flex-none rounded-pill bg-white px-[9px] py-1 text-[10px] font-bold uppercase tracking-[0.04em] text-ink-dim">Included · set by your school</span>
        </div>
        <div className="p-[6px_18px_10px]">
          {rows.map(([id, k, v, why]) => (
            <div key={id} className="border-b border-fill last:border-0">
              <button type="button" onClick={() => setOpenWhy(openWhy === id ? null : id)}
                className="flex w-full items-center justify-between gap-2.5 py-2.5 text-left text-sm">
                <span className="text-ink-dim">{k} <span className="text-[11px] text-line-strong">ⓘ</span></span>
                <b className="text-ink">{v}</b>
              </button>
              {openWhy === id && why ? (
                <div className="mb-2.5 rounded-lg bg-teal-faint p-[9px_12px] text-xs leading-[1.5] text-teal-mute">{why}</div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
      <div className="mb-[22px] text-[12.5px] leading-[1.6] text-ink-faint">
        These are your school&apos;s minimums and they&apos;re locked in. Tap any line to see why {school.name} requires
        it. In a couple of steps you can add protection on top; buying less isn&apos;t possible here, on purpose.
      </div>
      <button type="button" onClick={onContinue}
        className="min-h-[52px] w-full rounded-card-lg text-base font-bold text-white"
        style={{ background: 'var(--school-accent)' }}>
        Continue
      </button>
    </>
  );
}
